import {css, html, nothing} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import {FilterView} from './filter-view';
import {IFilterable} from './interfaces/filterable';
import {Resource} from './resource';
import {ri, RunnerIdle} from './runner-idle';
import {formatResourceValue, formatDelta, formatTime} from './utils';

@customElement('ri-resources')
export class Resources extends FilterView {
  get resources(): Resource[] {
    return this.filterables as Resource[];
  }
  set resources(value) {
    this.filterables = value;
  }
  static override styles = [
    ...FilterView.styles,
    css`
      /** Override FilterView Styles */
      .top-container {
        height: auto;
      }
      .bottom-container {
        height: 100%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        overflow-y: auto;
        margin: -4px;
      }
      .bottom-container * {
        margin: 4px 4px 0px;
        width: calc(100% - 8px);
      }

      /* .space-filling {
        width: 100%;
        height: 100%;
      } */

      /** Net Changes stuff */

      #queue-loop-delta {
        max-height: 25%;
      }
      #queue-loop-delta.container {
        overflow-y: auto;
      }

      .ri-loop-delta {
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        background-color: rgb(var(--value-color), 0.2);
      }

      .ri-loop-delta-label {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 40%;
      }
    `,
  ];
  override name = '资源';
  override subtitle = '只有一些是永远不够的。';
  override intersection = true;
  override possibleFilters = new Set([
    {name: 'body', displayName: 'Body'},
    {name: 'mind', displayName: 'Mind'},
    {name: 'train', displayName: 'Training'},
    {name: 'meditate', displayName: 'Meditation'},
    {name: 'food', displayName: 'Food'},
    {name: 'special', displayName: 'Special'},
    {name: 'experience', displayName: 'XP'},
    {
      name: 'hiddenByPlayer',
      displayName: 'Hidden',
      condition: (a) => a.hiddenByPlayer,
    },
  ]);
  override filters = new Set([]);

  override render() {
    const superRender = super.render();
    return html`
    ${superRender}
      <div class='space-filling'><hr/></div>
        <div id="queue-loop-delta">
          <h4>Net Changes Last Loop</h4>
          <div class=".container">
            ${function () {
              return unsafeHTML(
                Object.entries(ri.lastQueueLoopDelta)
                  .filter(([_string, filterable]) => {
                    if ('unlocked' in filterable && !filterable.unlocked)
                      return false;
                    let include = this.intersection;
                    for (const filter of this.filters) {
                      // Skip any special filters
                      if (
                        [...this.possibleFilters].find((f) => f.name === filter)
                          ?.condition
                      )
                        continue;
                      if (this.intersection) {
                        if (!filterable.tags.has(filter)) {
                          include = false;
                          break;
                        }
                      } else {
                        if (filterable.tags.has(filter)) {
                          include = true;
                          break;
                        }
                      }
                    }
                    for (const filter of this.possibleFilters) {
                      if (filter.condition) {
                        if (filter.only) {
                          if (this.filters.has(filter.name)) {
                            include = filter.condition(filterable);
                          }
                          continue;
                        }
                        if (
                          !this.filters.has(filter.name) &&
                          filter.condition(filterable)
                        ) {
                          include = false;
                          break;
                        }
                      }
                    }
                    return include;
                  })
                  .sort(this.compare)
                  .filter(
                    (entry) =>
                      !entry[1].value.equals(0) ||
                      (entry[1].capacity && !entry[1].capacity.equals(0))
                  )
                  // Repeatedly searching like this is expensive
                  .filter((entry) => {
                    const unlockable = ri.unlockables.find(
                      (e) => e.name == entry[0]
                    );
                    if (unlockable) return unlockable.unlocked;
                    return true;
                  })
                  .map((entry) => {
                    const unlockable = ri.unlockables.find(
                      (e) => e.name == entry[0]
                    );
                    return `
                <div class="ri-loop-delta ${entry[0]}" ${
                      entry[0] == 'distance' || unlockable?.unlocked
                        ? ''
                        : 'hidden'
                    }>
                  <div class="ri-loop-delta-label">
                    <span class="fancy ${unlockable?.name}">${
                      unlockable ? unlockable.displayName : entry[1].displayName
                    }</span>
                    ${formatResourceValue(entry[1].value)}
                  </div>
                  <span>${
                    entry[1]?.capacity && !entry[1].capacity.equals(0)
                      ? ` Capacity ${formatDelta(entry[1].capacity)}`
                      : ''
                  }</span>
                  <span>${formatDelta(entry[1].perSecond)}/s
                    </span>
                    <span class="${
                      entry[1].perSecond?.lt(0) ? 'danger' : ''
                    }">${
                      entry[1].timeToFullOrEmpty
                        ? formatTime(entry[1].timeToFullOrEmpty())
                        : ''
                    }</span>
                  </div>`;
                  })
                  .join('')
              );
            }.bind(this)()}
          </div>
        </div>
      </div>`;
  }
}
